export const PrinterErrorMap = [
  { key: 'NO_ERROR', ios: 0, android: 0 },
  { key: 'PRINT_SETTINGS_ERROR', ios: 1, android: 1 },
  { key: 'INVALID_ARGUMENT_ERROR', ios: null, android: 2 },
  { key: 'FILEPATH_URL_ERROR', ios: 2, android: 3 },
  { key: 'PDF_PAGE_ERROR', ios: 3, android: 4 },
  { key: 'PRINT_SETTINGS_NOT_SUPPORT_ERROR', ios: 4, android: 5 },
  { key: 'DATA_BUFFER_ERROR', ios: 5, android: 6 },
  { key: 'PRINTER_MODEL_ERROR', ios: 6, android: 7 },
  { key: 'WORK_PATH_ERROR', ios: null, android: 8 },
  { key: 'CANCELED', ios: 7, android: 9 },
  { key: 'CHANNEL_TIMEOUT', ios: 8, android: 10 },
  { key: 'SET_MODEL_ERROR', ios: 9, android: 11 },
  { key: 'UNSUPPORTED_FILE', ios: 10, android: 12 },
  { key: 'UNSUPPORTED_OS_VERSION', ios: null, android: 13 },
  { key: 'SET_MARGIN_ERROR', ios: 11, android: 14 },
  { key: 'SET_LABEL_SIZE_ERROR', ios: 12, android: 15 },
  { key: 'CUSTOM_PAPER_SIZE_ERROR', ios: 13, android: 16 },
  { key: 'SET_LENGTH_ERROR', ios: 14, android: 17 },
  { key: 'TUBE_SETTING_ERROR', ios: 15, android: 18 },
  { key: 'CHANNEL_ERROR_STREAM_STATUS_ERROR', ios: 16, android: 19 },
  { key: 'CHANNEL_ERROR_UNSUPPORTED_CHANNEL', ios: 17, android: 20 },
  { key: 'PRINTER_STATUS_ERROR_PAPER_EMPTY', ios: 18, android: 21 },
  { key: 'PRINTER_STATUS_ERROR_COVER_OPEN', ios: 19, android: 22 },
  { key: 'PRINTER_STATUS_ERROR_BUSY', ios: 20, android: 23 },
  { key: 'PRINTER_STATUS_ERROR_PRINTER_TURNED_OFF', ios: 21, android: 24 },
  { key: 'PRINTER_STATUS_ERROR_BATTERY_WEAK', ios: 22, android: 25 },
  { key: 'PRINTER_STATUS_ERROR_EXPANSION_BUFFER_FULL', ios: 23, android: 26 },
  { key: 'PRINTER_STATUS_ERROR_COMMUNICATION_ERROR', ios: 24, android: 27 },
  { key: 'PRINTER_STATUS_ERROR_PAPER_JAM', ios: 25, android: 28 },
  { key: 'PRINTER_STATUS_ERROR_MEDIA_CANNOT_BE_FED', ios: 26, android: 29 },
  { key: 'PRINTER_STATUS_ERROR_OVER_HEAT', ios: 27, android: 30 },
  { key: 'PRINTER_STATUS_ERROR_HIGH_VOLTAGE_ADAPTER', ios: 28, android: 31 },
  { key: 'PRINTER_STATUS_ERROR_MOTOR_SLOW', ios: 29, android: 32 },
  { key: 'PRINTER_STATUS_ERROR_UNSUPPORTED_CHARGER', ios: 30, android: 33 },
  {
    key: 'PRINTER_STATUS_ERROR_INCOMPATIBLE_OPTIONAL_EQUIPMENT',
    ios: 31,
    android: 34,
  },
  { key: 'PRINTER_STATUS_ERROR_UNKNOWN_ERROR', ios: 32, android: 35 },
  { key: 'TEMPLATE_PRINT_NOT_SUPPORTED', ios: 33, android: null },
  { key: 'INVALID_TEMPLATE_KEY', ios: 34, android: null },
  { key: 'UNKNOWN_ERROR', ios: 35, android: 36 },
  { key: 'NO_ERROR', ios: 30000, android: 30000 },
  { key: 'OPEN_STREAM_FAILURE', ios: 30001, android: 30001 },
  { key: 'TIMEOUT', ios: 30002, android: 30002 },
] as const;

export function mapPlatformErrorToKey(
  platform: 'ios' | 'android',
  errorCode: number,
): typeof PrinterErrorMap[number]['key'] {
  const match = PrinterErrorMap.find(e => e[platform] === errorCode);
  return match?.key || 'UNKNOWN_ERROR';
}
